import { Paper, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import ContractsTable from '../../components/contracts-table/contracts-table';

import { ErrorPage } from './page.error';

import { FullMainHeight } from '@ui';

export function ContractsPage() {
  const { t } = useTranslation();

  return (
    <FullMainHeight.Root>
      <FullMainHeight.Header>
        <Paper>
          <Title order={2}>{t('contracts.contracts-title')}</Title>
        </Paper>
      </FullMainHeight.Header>
      <FullMainHeight.Content>
        <ContractsTable />
      </FullMainHeight.Content>
    </FullMainHeight.Root>
  );
}

ContractsPage.Error = ErrorPage;

export default ContractsPage;
